import './_loader.scss';

const Loader = (props) => {

    const {visible, infos} = props

    return (
        <div className="loader-container" style={{
                opacity: visible ? 1 : 0,
                transition: "opacity 500ms ease-in-out",
                pointerEvents: visible ? "auto" : "none",
            }}>
            <div className="loader" />
            { infos ?
            <p>Chargement...</p>
            : <></>
            }
        </div>
    );
};

export default Loader;